/* eslint-disable */ 

(function() {

    var VideoRotator = window.VideoRotator = function( stateController, settings ) {

        var my = this;

        //
    
        my.settings = settings;
        my.stateController = stateController;
    
        my.active = false;

        //

        var _rx = 0, _ry = 0, rx = 0, ry = 0, vx = 0, vy = 0;

        var pan = { x:0, _x:-1, y:0, _y:-1 };

        var time = my.time = 0, _time = -1, quantizedTime = -1, _quantizedTime = -1, speedMultiplier = 1;

        var zoom = 0, _zoom = 0;
        
        var lastInteractionTimestamp = -1, lastTapTimestamp = -1, dimensions = {};

        var hotspots = [],
            hotspotElements = my.settings.container.querySelectorAll('[data-hotspot]'),
            hotspotScale = -1,
            hotspotOrder = [];

        //

        var video = my.settings.container.querySelector('video'),
            imageContainer = my.settings.container.querySelector('[data-images]'),
            highQualityImage = my.settings.container.querySelector('[data-overlay]'),
            headTrackerIndicator = my.settings.container.querySelector('[data-indicator]'),
            headTrackerIndicatorGradient = my.settings.container.querySelector('[data-indicator-gradient]'),
            background = my.settings.container.querySelector('[data-background]');

        var highQualityImagePath = "", highQualityImageCount;

        var isRTL = document.querySelector('html').getAttribute('dir') === "rtl",
            isIE = my.stateController.isIE,
            isHandInteracting = false,
            isHighQualityImageHandled = false,
            isLoop = true,
            useZoom = my.stateController.isMobile,
            useFineHeadTracking = true,
            useHighQualityImages = true,
            useBasicMode = my.stateController.isMobile;

        //

        var CONSTANTS = {
            HEADTRACKERSPEED: 0.002, 
            HEADTRACKERPADDING: 0.3, 
            MOUSESPEED: 0.3, 
            TOUCHSPEED: 0.2, 
            DEFAULTVIDEOASPECT: 16 / 9, 
            TIMEQUANT: 30,
            HEADTRACKERFINESPEED: 0.005,
            HEADTRACKERFINEPADDING: 0.4,
            HIGHQUALITYIMAGEDELAY: 600,
            HOTSPOTDELAY: 1000,
            DOUBLETAPMAXDISTANCE:15,
            DOUBLETAPMAXDURATION:800
        };

        //
                
        highQualityImage.onload = function(){ window.setTimeout( function() { if (isHighQualityImageHandled) { highQualityImage.style.visibility = "visible"; } }, 10) };

        highQualityImage._src = "";

        background.style.cursor = "grab";

        //

        for (let index = 0; index < hotspotElements.length; index++) {

            const element = hotspotElements[index];
            
            element.style.cursor = "pointer";

            element.addEventListener( 'click', function(e){

                e.preventDefault();
                e.stopPropagation();

                //

                my.dispatchEvent('VIDEONAVIGATION', { destination:element._hotspot.action.destination, data:element._hotspot, sourceImage: undefined } );

            }, false );

        }
    
        //
        
        // window.addEventListener('TRACKINGFOUND', function(e){ });
    
        // window.addEventListener('TRACKINGLOST', function(e){ });

        window.addEventListener('TRACKINGSTOP', function(e){

            headTrackerIndicator.style.opacity = 0;

            vx = 0;
            vy = 0;

        });

        window.addEventListener('TRACKINGMOVED', function(e){

            if (!my.active) return;

            if (!my.stateController.useHeadTracking) return;

            if (isHandInteracting) return;

            //

            rx = e.detail.rx;
            ry = e.detail.ry;

            //

            headTrackerIndicator.style.opacity = 1;

            //

            var m = 0.5;
            var r = (Math.clamp(-ry,-m,m))/m;

            // 

            const str = "polygon(50% 0%, " + (r*50+50) + "% 0%, " + (r*50+50) + "% 100%, 50% 100%)";

            headTrackerIndicatorGradient.style.clipPath = str;

            //

            vx = 0;

            if (useFineHeadTracking) {

                const ar = Math.abs(r);

                if (ar>CONSTANTS.HEADTRACKERFINEPADDING) {

                    vx = (ar-CONSTANTS.HEADTRACKERFINEPADDING) * CONSTANTS.HEADTRACKERFINESPEED * ((ry>0)?1:-1);

                    lastInteractionTimestamp = Date.now();
    
                    highQualityImage.style.visibility = "hidden";
                    highQualityImage.src = "";
                    isHighQualityImageHandled = false;

                }

            } else {

                if (e.detail.ry>CONSTANTS.HEADTRACKERPADDING) {
                    vx = -CONSTANTS.HEADTRACKERSPEED;
                    lastInteractionTimestamp = Date.now();
    
                    highQualityImage.style.visibility = "hidden";
                    highQualityImage.src = "";
                    isHighQualityImageHandled = false;
                }
    
                if (e.detail.ry<-CONSTANTS.HEADTRACKERPADDING) {
                    vx = CONSTANTS.HEADTRACKERSPEED;
                    lastInteractionTimestamp = Date.now();
    
                    highQualityImage.style.visibility = "hidden";
                    highQualityImage.src = "";
                    isHighQualityImageHandled = false;
                }

            }

        });

        //

        background.addEventListener( 'mousedown', function(e){

            isHandInteracting = true;

            my.mouseDownTime = time;
            my.mouseDownLoc = {x:e.clientX,y:e.clientY};

            background.style.cursor = "grabbing";

            window.addEventListener('mouseup',mouseup);
            window.addEventListener('mousemove',mousemove);

        }, false );

        function mousemove(e){

            if (!my.active) return;

            if (!isHandInteracting) return;
                    
            //

            var d = e.clientX - my.mouseDownLoc.x;

            time = my.mouseDownTime - (d/window.innerWidth)*CONSTANTS.MOUSESPEED*speedMultiplier;

            //

            highQualityImage.style.visibility = "hidden";
            highQualityImage.src = "";
            isHighQualityImageHandled = false;

            //

            lastInteractionTimestamp = Date.now();

        }

        function mouseup() {

            isHandInteracting = false;

            window.removeEventListener('mouseup',mouseup);
            window.removeEventListener('mousemove',mousemove);

            background.style.cursor = "grab";

        }

        //

        background.addEventListener('touchstart', function(e){

            e.preventDefault();
            e.stopPropagation();

            //

            isHandInteracting = true;

            //

            if (my.latestTouchInteraction!==undefined) my.previousTouchInteraction = my.latestTouchInteraction;

            my.latestTouchInteraction = {
                fingers: (e.touches.length===1) ? 1 : 2,
                touchDownVideoTime: time,
                touchDownLoc: {x:e.touches[0].clientX,y:e.touches[0].clientY},
                touchMaxDistanceTravelled: 0,
                touchDownZoom: _zoom,
                touchDownTimestamp: Date.now(),
            };

            if (e.touches.length>1)  my.latestTouchInteraction.touchDownTwoFingerSeperation = Math.sqrt( Math.pow(e.touches[0].clientX-e.touches[1].clientX,2) + Math.pow(e.touches[0].clientY-e.touches[1].clientY,2) );

        }, {passive:false} );

        background.addEventListener('touchmove', function(e){

            if (!my.active) return;
        
            if (!isHandInteracting) return;

            e.preventDefault();
            e.stopPropagation();
            
            //

            if (e.touches.length>1) {
                
                if (useZoom) {

                    var d = Math.sqrt( Math.pow(e.touches[0].clientX-e.touches[1].clientX,2) + Math.pow(e.touches[0].clientY-e.touches[1].clientY,2) );

                    if (my.latestTouchInteraction.touchDownTwoFingerSeperation===undefined) my.latestTouchInteraction.touchDownTwoFingerSeperation = d;

                    if (d>my.latestTouchInteraction.touchDownTwoFingerSeperation*1.5) {

                        if (my.latestTouchInteraction.touchDownZoom==0) _zoom = 1;

                    }

                    if (d<my.latestTouchInteraction.touchDownTwoFingerSeperation*0.5) {

                        if (my.latestTouchInteraction.touchDownZoom==1) _zoom = 0;

                    }

                }

                my.latestTouchInteraction.fingers = 2;

            } else {

                var d = e.touches[0].clientX - my.latestTouchInteraction.touchDownLoc.x;

                time = my.latestTouchInteraction.touchDownVideoTime - (d/dimensions.width)*CONSTANTS.TOUCHSPEED*speedMultiplier;

                //

                highQualityImage.style.visibility = "hidden";
                highQualityImage.src = "";
                isHighQualityImageHandled = false;

                //

                var d = Math.sqrt( Math.pow(e.touches[0].clientX-my.latestTouchInteraction.touchDownLoc.x,2) + Math.pow(e.touches[0].clientY-my.latestTouchInteraction.touchDownLoc.y,2) );

                if (d > my.latestTouchInteraction.touchMaxDistanceTravelled) my.latestTouchInteraction.touchMaxDistanceTravelled = d;

            }

            //

            lastInteractionTimestamp = Date.now();

        }, {passive:false} );
        
        background.addEventListener('touchend', function(e){

            if (!my.active) return;
        
            isHandInteracting = false;

            //

            if (my.previousTouchInteraction!==undefined) {
                
                // has been at least two interactions

                if (!my.previousTouchInteraction.used) {

                    // previous taps weren't already used in double-tap

                    if (my.latestTouchInteraction.fingers===1 && my.previousTouchInteraction.fingers===1) {

                        // not a zoom

                        if (Date.now() - my.previousTouchInteraction.touchDownTimestamp < CONSTANTS.DOUBLETAPMAXDURATION) {

                            // very short time
    
                            if (my.latestTouchInteraction.touchMaxDistanceTravelled<CONSTANTS.DOUBLETAPMAXDISTANCE) {

                                // very small distance
                                
                                if (my.previousTouchInteraction.touchMaxDistanceTravelled<CONSTANTS.DOUBLETAPMAXDISTANCE) {
    
                                    _zoom = (_zoom==0)?1:0; 
    
                                    lastInteractionTimestamp = Date.now();
    
                                    my.latestTouchInteraction.used = true;
    
                                }
    
                            }
    
                        }
    
                    }

                }

            }

        }, {passive:false} );

        //

        window.addEventListener('VIDEOROTATORLOAD', function(e){

            video.src = (e.detail.blob)? e.detail.blob : e.detail.data.src;
            video.pause();
            video.style.display = "block";
            
            //

            _rx = 0;
            _ry = 0;
            
            time = 0;
            _time = -1;

            quantizedTime = 0;
            quantizedTime = -1;

            _zoom = 0;
            zoom = 0;

            pan = { x:0,_x:-1,y:0,_y:-1 };

            if (!my.active) {
                my.active = true; 
                my.render();
            }

            //

            highQualityImage.style.opacity = 1;
            highQualityImage.style.visibility = "hidden";
            highQualityImage.src = "";

            lastInteractionTimestamp = Date.now();

            lastTapTimestamp = -1;

            isHighQualityImageHandled = false;

            speedMultiplier = 1;

            //

            if (e.detail.destinationImage!==undefined) {
                
                isHighQualityImageHandled = true;

                highQualityImage.src = e.detail.destinationImage;
                highQualityImage._src = e.detail.destinationImage;

                if (highQualityImage.complete) highQualityImage.style.visibility = "visible";

            }
            
            //

            useHighQualityImages = (e.detail.data.images!==undefined) ? true : false;

            if (useHighQualityImages) {

                highQualityImagePath = e.detail.data.images;
                highQualityImageCount = e.detail.data.imageCount;

            }                

            //

            isLoop = (e.detail.data.loop) ? true : false;

            //

            if (e.detail.data.speedMultiplier) {
             
                speedMultiplier = parseFloat(e.detail.data.speedMultiplier);

            }

            //

            if (e.detail.data.initialTime) {
             
                time = parseFloat(e.detail.data.initialTime);

            }

            //

            if (e.detail.data.background!==undefined) {

                background.style.backgroundImage="url("+e.detail.data.background+")";

            }

            //

            for (let index = 0; index < hotspotElements.length; index++) {

                hotspotElements[index].style.visibility = "hidden";

            }

            //

            var hotspotInformation = e.detail.data.hotspots;

            if (hotspotInformation!==undefined) {

                hotspots = [];

                for (let index = 0; index < hotspotInformation.length; index++) {
                    
                    var hotspotData = hotspotInformation[index];

                    var hotspot = {
                        x: hotspotData.x*2.2,
                        y: hotspotData.y,
                        z: hotspotData.z*3,
                        normal: hotspotData.normal,
                        opacity:0,
                        type: hotspotData.type,
                        css: hotspotData.css,
                        name: hotspotData.name,
                        action: hotspotData.action,
                        element: hotspotElements[index],
                    }

                    hotspots.push(hotspot);

                    //

                    hotspot.element.className = "c-nx-spin__hotspot "+hotspot.css;

                    hotspot.element._hotspot = hotspot;
                    
                }

            } else {

                hotspots = [];

            }

            //

            my.resize();
            
        } );

        window.addEventListener('VIDEOROTATOREJECT', function(e){

            video.style.display = "none";

            my.active = false;                

        } );

        window.addEventListener( 'resize', function() { 
        
            if (my.resizeTimeout!==undefined) return;
            
            my.resizeTimeout = this.setTimeout(function(){
    
                my.resize();
    
                my.resizeTimeout = undefined;
    
            }, 50);
            
        }, false );

        //

        my.resize = function() {

            if (!my.active) return;

            //

            var videoAspect = CONSTANTS.DEFAULTVIDEOASPECT;

            var containerRect = my.settings.container.getBoundingClientRect();

            var winWidth = containerRect.width; // window.innerWidth;
            var winHeight = containerRect.height; // window.innerHeight;

            var winAspect = winWidth / winHeight;

            var w,h;

            if (winAspect>videoAspect) {
            
                w = (winWidth+80);
                h = w / videoAspect;
                                        
            } else {
                
                h = (winHeight+40);
                w = h * videoAspect;
                            
            }

            if (useZoom) {
                w = winWidth*(1-zoom) + w*zoom;
                h = w / videoAspect;
            }

            video.style.width = w + "px";
            video.style.height = h + "px";

            if (useHighQualityImages) {
                imageContainer.style.width = w + "px";
                imageContainer.style.height = h + "px";
            }

            hotspotScale = w*0.075;  

            dimensions = {
                width: winWidth,
                height: winHeight,
                halfWidth: winWidth/2,
                halfHeight: winHeight/2,
            };

        };
    
        my.render = function() {

            if (!my.active) return;

            if (useBasicMode) {

                window.setTimeout(function(){ my.render(); }, 1000/24);

            } else {
                
                requestAnimationFrame(function(){ my.render(); });

            }

            //

            _rx += (rx-_rx)*0.1;
            _ry += (ry-_ry)*0.1;

            time += vx * speedMultiplier;

            //

            if (zoom!=_zoom) {

                if (zoom<_zoom) {
                    zoom = Math.clamp(zoom+0.1,0,1);
                } else {
                    zoom = Math.clamp(zoom-0.1,0,1);
                }

                my.resize();

            }

            //

            if (isLoop) {
                time = time-Math.floor(time);
            } else {
                time = Math.min(Math.max(time,0),1);
            }

            //

            if (!isNaN(video.duration)) {

                var howLongSinceUserInteracted = Date.now() - lastInteractionTimestamp;

                if (_time!=time) {

                    quantizedTime = Math.round(time*video.duration*25);

                    if (_quantizedTime!=quantizedTime) {

                        video.currentTime = quantizedTime/25;

                        _quantizedTime = quantizedTime;

                    }
                
                    _time = time;

                    // console.log(time); use if you need to make a note of timecodes etc

                }

                if (useHighQualityImages) {
    
                    if (howLongSinceUserInteracted>CONSTANTS.HIGHQUALITYIMAGEDELAY) {
                        
                        if (!isHighQualityImageHandled) {
                            
                            var offsetTime = ( (isLoop) ? (time+1.00/highQualityImageCount) : time ); 

                            if (isLoop) offsetTime = offsetTime - Math.floor(offsetTime);
                            
                            var f = "0"+Math.floor(offsetTime*(highQualityImageCount));

                            //var f = "0"+Math.floor(quantizedTime/video.duration/25*highQualityImageCount);
                                    
                            if (f.length!=4) f = "0"+f;
                            if (f.length!=4) f = "0"+f;
                            if (f.length!=4) f = "0"+f;
            
                            f = highQualityImagePath.split("xxxx").join(f);
                
                            if (highQualityImage._src!=f) {

                                highQualityImage.src = f;
                                highQualityImage._src = f;

                                // if (highQualityImage.complete) highQualityImage.style.visibility = "visible"; // onload won't trigger if previously loaded

                            }
    
                            isHighQualityImageHandled = true;
    
                        }
                        
                    }
    
                }

                if (hotspots.length!==0) {

                    if (howLongSinceUserInteracted>CONSTANTS.HOTSPOTDELAY) {

                        if (hotspotOrder.length==0) {
                            
                            // calculation position and visibility

                            for (let index = 0; index < hotspots.length; index++) {
                                const hotspot = hotspots[index];
        
                                const p = Math.rotateY(hotspot,time*Math.PI*2);
                                const n = Math.rotateY(hotspot.normal,time*Math.PI*2);
                
                                const x = (p.x*hotspotScale);
                                const y = (p.y*hotspotScale);

                                if ( (n.z>0.1|n.y==1) && (x>-dimensions.halfWidth*0.9) && (x<dimensions.halfWidth*0.9) && (y>-dimensions.halfHeight)) {

                                    // is visible

                                    hotspot._resolvedP = p;
                                    hotspot._resolvedN = n;
                                    hotspot._rx = x;
                                    hotspot._ry = y;

                                    hotspotOrder.push(hotspot);

                                }

                            }

                            // sort depending on x position

                            hotspotOrder.sort(function(a, b) {
                                return (a._resolvedP.y) - (b._resolvedP.y);
                            });

                        }

                        //

                        for (let index = 0; index < hotspotOrder.length; index++) {
                            const hotspot = hotspotOrder[index];

                            if (my.stateController.isIE && isRTL) {

                                hotspot.element.style.transform = "translate("+hotspot._rx+"px,"+hotspot._ry+"px) translate(50vw,50vh) translate(50%,-50%) scale("+(Math.clamp(hotspot.opacity+0.5,0,1))+")";

                            } else {

                                hotspot.element.style.transform = "translate("+hotspot._rx+"px,"+hotspot._ry+"px) translate(50vw,50vh) translate(-50%,-50%) scale("+(Math.clamp(hotspot.opacity+0.5,0,1))+")";

                            }
                            
                            if ((howLongSinceUserInteracted>(1200+index*400)) && ((zoom==1)|!useZoom)) {
                                if (hotspot.opacity == 0) {
                                    hotspot.element.classList.add("go");
                                    hotspot.element.style.visibility = "visible";
                                }
                                hotspot.opacity = Math.clamp(hotspot.opacity+((useBasicMode)? 0.1 : 0.02),0,1);
                                hotspot.element.style.opacity = hotspot.opacity;
                            } else {
                                hotspot.opacity = 0;
                            }
                    
                        }                       

                    } else {

                        if (hotspotOrder.length!=0) {
                        
                            hotspotOrder = [];
                        
                            for (let index = 0; index < hotspotElements.length; index++) {
        
                                hotspotElements[index].style.visibility = "hidden";
                                hotspotElements[index].classList.remove("go");
                               
                            }

                            for (let index = 0; index < hotspots.length; index++) {
        
                                hotspots[index].opacity = 0;
                               
                            }

                        }

                    }

                }

            }

        };

        my.dispatchEvent = function( name, eventDetail ) {
        
            if (my.stateController.debugMode) console.log( "EVENT", name, eventDetail );
        
            var thisEvent;
        
            if (my.stateController.isIE) {
        
                // IE11 doesn't support native customEvent....
                thisEvent = document.createEvent("CustomEvent");
                thisEvent.initCustomEvent(name, true, true, eventDetail);
        
            } else {
        
                thisEvent = new CustomEvent(name, { "detail": eventDetail });
        
            }
        
            my.stateController.eventDispatcher.dispatchEvent( thisEvent );
        
        };

    };

    Math.fract = function(n) { return n-Math.floor(n); };

    Math.clamp = function(n, min, max) { return Math.min(Math.max(n, min), max); };

    Math.wrap = function(x,n) { return (x % n + n) % n; };
  
    Math.rotateY = function(v,angle,target) {

        if (target==undefined) target = {x:0,y:0,z:0};

        var s=Math.sin(angle);
        var c=Math.cos(angle);

        target.y = v.y;
        target.z = c * v.z - s * v.x;
        target.x = s * v.z + c * v.x;

        return target;

    };

  })();
define("spin/video-rotator", function(){});

